import { Items } from "@pdfking/tfunc"

import { is_mapping } from "./is_mapping"
import { ordered_object } from "./ordered_object"
import { to_array } from "./to_array"

export const map = (f, iterable) => {
  // we want to return a new object if iterable is an object

  if (is_mapping(iterable)) {
    return ordered_object(Items(iterable).map(a => [a[0], f(a[1], a[0])]))
  }
  return to_array(iterable).map(f)
}
